import isRowOmitted from './isRowOmitted';

type Row = Record<string, unknown>;

const isADuplicate = (rowValues: Row): boolean => Boolean(rowValues._associatedWithId);

const canRunAutofillOnRow = (rowValues: Row | null): boolean => Boolean(rowValues && !isADuplicate(rowValues) && !isRowOmitted(rowValues));

export default canRunAutofillOnRow;
